<div class="activar-container">
  <div class="activar-card">
    <div class="activar-brand">
      <img src="/assets/shell/logos/logo-nebula.svg" alt="Nebula ERP" class="activar-logo" />
    </div>

    <!-- Validando el enlace -->
    @if (estado() === 'validando') {
      <div class="activar-estado">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Validando tu enlace de activación…</p>
      </div>
    }

    <!-- Enlace inválido o expirado -->
    @if (estado() === 'invalido') {
      <div class="activar-estado">
        <mat-icon class="icono-error">error_outline</mat-icon>
        <h2>Enlace no válido</h2>
        <p>
          Este enlace de activación no existe, ya fue usado o expiró. Solicita al administrador que
          te regenere el enlace.
        </p>
        <button mat-stroked-button color="primary" (click)="irAlLogin()">
          Ir al inicio de sesión
        </button>
      </div>
    }

    <!-- Formulario de definición de contraseña -->
    @if (estado() === 'formulario' || estado() === 'enviando') {
      <h2>Activa tu cuenta</h2>
      <p class="activar-sub">Define tu contraseña para completar la activación.</p>

      <form [formGroup]="form" (ngSubmit)="confirmar()" class="activar-form">
        <mat-form-field appearance="outline">
          <mat-label>Contraseña</mat-label>
          <input matInput type="password" formControlName="password" autocomplete="new-password" />
          @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
            <mat-error>La contraseña es obligatoria</mat-error>
          }
          @if (form.get('password')?.hasError('minlength')) {
            <mat-error>Mínimo 8 caracteres</mat-error>
          }
          @if (form.get('password')?.hasError('pattern')) {
            <mat-error>Debe incluir mayúscula, minúscula, número y símbolo</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Confirmar contraseña</mat-label>
          <input matInput type="password" formControlName="confirmar" autocomplete="new-password" />
          @if (form.hasError('noCoinciden') && form.get('confirmar')?.touched) {
            <mat-error>Las contraseñas no coinciden</mat-error>
          }
        </mat-form-field>

        <ul class="activar-politica">
          <li>Al menos 8 caracteres</li>
          <li>Una mayúscula y una minúscula</li>
          <li>Un número y un símbolo</li>
        </ul>

        @if (error()) {
          <div class="activar-error">{{ error() }}</div>
        }

        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="activar-boton"
          [disabled]="estado() === 'enviando'"
        >
          @if (estado() === 'enviando') {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Activar cuenta
          }
        </button>
      </form>
    }

    <!-- Activación completada -->
    @if (estado() === 'listo') {
      <div class="activar-estado">
        <mat-icon class="icono-ok">check_circle</mat-icon>
        <h2>¡Cuenta activada!</h2>
        <p>Tu contraseña quedó definida. Te llevamos al inicio de sesión…</p>
      </div>
    }
  </div>
</div>
